export default {"src":"/_next/static/media/student.81591698.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};